<template>
  <div class="wrapper-header">
    <div class="content-header">
      <img src="@/assets/logo/LogoYellow.svg" alt="" class="logo" />
      <div class="close" @click="closeSession">
        <img src="@/assets/menu/Close.svg" alt="" class="icon-close" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LoginView",

  setup(props, context) {
    function closeSession() {
      context.emit("close");
    }

    return {
      closeSession,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/layout/styles/headerStyle";
</style>


